import { render, staticRenderFns } from "./homenew.vue?vue&type=template&id=dafb1056&scoped=true&"
import script from "./homenew.vue?vue&type=script&lang=js&"
export * from "./homenew.vue?vue&type=script&lang=js&"
import style0 from "./homenew.vue?vue&type=style&index=0&id=dafb1056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafb1056",
  null
  
)

export default component.exports